import React, { useEffect, useRef, useState } from "react";
import VariablesFilterModal from '../../components/VariablesList/VariablesFilterModal/VariablesFilterModal'
import { observer } from "mobx-react";
import { useMobXStore } from "../../hooks/useMobXStore";
import VariableList from "../../components/VariablesList/VariableList";
import VariableDetails from "../../components/VariableDetails/VariableDetails";
import { TdsButton } from "@scania/tegel-react";
import { useUserRole } from "../../hooks/useUserRole";
import { UserActionContext } from "../../AppContext";
import { FormProvider, useForm } from "react-hook-form";

//Styles
import "./VariableEditor.scss";
import { newVariable } from "../../helpers/dataHelper";
import { updateVersion } from "../../helpers/updateVersion";
import _ from "lodash";

const VariableEditor = () => {

  const { variableListStore, variableDetailsStore } = useMobXStore()
  const selectedVariableId = variableDetailsStore.selectedVariable
  const [selectedVariableDetails, setSelectedVariableDetails] = useState(variableDetailsStore.selectedVariableDetails)
  const { isEditor } = useUserRole()
  const sortableTable = useRef<HTMLTdsTableElement>(null);
  const tableData = variableListStore.sortedFilteredTableData;
  const isLoadingVariableList = variableListStore.isLoadingVariableList;
  const isLoadingVariableDetails = variableDetailsStore.isLoadingVariableDetails;
  const [action, setAction] = useState<ActionType>('read');
  const [updateWithVersion, setUpdateWithVersion] = useState(false);
  const methods = useForm({ defaultValues: newVariable });
  const { reset } = methods;
  const [variableStatus, setVariableStatus] = useState<VariableStatusType>('');
  const [variableData, setVariableData] = useState<VariableDetail>(newVariable);

  const clearSelectedVariable = () => {
    variableDetailsStore.clearSelectVariable();
  }

  const handleRowClick = (rowId: any) => {
    variableDetailsStore.selectVariableForViewing(rowId);
    setAction('read'); //update mode in context
  };

  const setSearchId = (value: string) => {
    variableListStore.setSearchId(value);
  }

  const setSearchName = (value: string) => {
    variableListStore.setSearchName(value);
  }

  const setSearchVersion = (value: string) => {
    variableListStore.setSearchVersion(value);
  }

  const handleCreateVariableDetails = (variableDetails: VariableDetail) => {
    variableDetailsStore.createVariableDetails(variableDetails);
  };

  const handleUpdateVariableDetails = (variableDetails: VariableDetail) => {
    if (variableDetails.id) {
      variableDetailsStore.updateVariableDetails(variableDetails.id, variableDetails);
    }
  }
  const onValidData = (data: VariableDetail) => {
    console.log("Variable Status :", variableStatus);
    // console.log('log valid data: ', data)

    if (data.type === 'class') {
      if (data.boundaries && data.boundaries instanceof String) {
        data.boundaries = data.boundaries.split(',').map((item: string) => parseFloat(item.trim()));
      }
    }
    if (data.value_names) {
      data.value_names = _.chain(data.value_names)
        .keyBy('hexCode')
        .mapValues('name')
        .value();
    }
    setVariableData(data);
  };

  const onInValidData = (data: any) => {
    console.log("log Invalid Data", data);
  };

  const detectUserAction = (userAction: string) => {
    if (userAction === "Save as draft") {
      if (selectedVariableDetails?.status === '') setVariableStatus('Created')
    }
    if (userAction === "Move to test") setVariableStatus('Test')
    if (userAction === "Update with version") { setVariableStatus('Created'); setUpdateWithVersion(true); return; }
    if (userAction === "Update w/o version") { setVariableStatus('Published'); setUpdateWithVersion(false); return; }
    if (userAction === "Save") { }
    if (userAction === "Publish") { setVariableStatus('Published') }
    if (userAction === "Deprecate") { setVariableStatus('Deprecated') }
  };

  const handleCreateBtnClick = () => {
    setAction('create'); //update the action in context  
    variableDetailsStore.updateVariableDetailsForCreate(newVariable);
    reset(newVariable);
  }

  useEffect(() => {
    variableListStore.loadVariables()
  }, [variableListStore]);


  useEffect(() => {
    //Reset the form with new default values whenever selectedVariableDetails changes
    reset(selectedVariableDetails);
    //eslint-disable-next-line 
  }, [selectedVariableDetails]);

  useEffect(() => {
    setSelectedVariableDetails(variableDetailsStore.selectedVariableDetails)
  }, [variableDetailsStore.selectedVariableDetails]);

  //TODO: inside useEffect call API is not good way and Current Top panel is not supporting to call API with submit, need to modify below API call logic with top section button submit
  useEffect(() => {
    if (action === 'read') return;
    const updatedVariableData = { ...variableData, status: variableStatus };
    if (action === 'create' && updatedVariableData?.name) {
      handleCreateVariableDetails(updatedVariableData) // check and call the right method after integrating update flow
    } else if (action === 'edit' || action === 'update') {
      if (updateWithVersion) {
        const updatedVariableData = { ...variableData, status: variableStatus, id: undefined, version: updateVersion(variableData.version) };
        handleCreateVariableDetails(updatedVariableData)
        setUpdateWithVersion(false)
      } else {
        handleUpdateVariableDetails(updatedVariableData)
      }
    }
    reset()
    setAction('read')
    // variableDetailsStore.clearSelectVariable()
    //eslint-disable-next-line 
  }, [variableData]);

  return (
    <>
      <UserActionContext.Provider value={{ action, setAction, updateWithVersion, setUpdateWithVersion }}>
        <div className="content left">
          <VariableList
            setSearchId={setSearchId}
            setSearchName={setSearchName}
            handleRowClick={handleRowClick}
            setSearchVersion={setSearchVersion}
            tableData={tableData}
            sortableTable={sortableTable}
            isLoadingVariableList={isLoadingVariableList}
          />
          <VariablesFilterModal store={variableListStore} />
        </div>
        <div className="content right container">
          {(selectedVariableId >= 0) &&
            <FormProvider {...methods} >
              <form onSubmit={methods.handleSubmit(onValidData, onInValidData)}>
                <VariableDetails
                  selectedVariableId={selectedVariableId}
                  selectedVariableDetails={selectedVariableDetails}
                  clearSelectedVariable={clearSelectedVariable}
                  isLoadingVariableDetails={isLoadingVariableDetails}
                  isEditor={isEditor}
                  detectUserAction={detectUserAction}
                />
              </form>
            </FormProvider>
          }

          {selectedVariableId < 0 &&
            <>
              {!isEditor && <div className="vertical-center">
                <p>Select a variable from the list to view details</p>
              </div>}
              {isEditor && <div className="vertical-center edit-mode-message">
                <p>Select a variable from the list to view details or create a new variable</p>
                <TdsButton className='tds-u-mt2' onClick={handleCreateBtnClick} variant="primary" size="lg" text="Create"></TdsButton>
              </div>}

            </>
          }
        </div>
      </UserActionContext.Provider>
    </>
  );
};

export default observer(VariableEditor);
